import {
  GET_COURSE,
  GET_COURSE_SUCCESS,
  GET_COURSE_CLEAN,
  GET_COURSE_USER,
  GET_COURSE_USER_SUCCESS,
  GET_COURSE_USER_CLEAN,
  API_ERROR,
  GET_COURSE_USER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
  courseManagement: undefined,
}

const CourseGet = (state = initialState, action) => {
  switch (action.type) {
    case GET_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_COURSE_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        courseManagement: action.payload.course,
      }
      break
    case GET_COURSE_CLEAN:
      state = initialState
      break
    case GET_COURSE_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_COURSE_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        course: action.payload.course,
      }
      break
    case GET_COURSE_USER_CLEAN:
      state = initialState
      break
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    case GET_COURSE_USER_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default CourseGet
